import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { ModalService } from '@app/core/ui/modal/modal.service';
import { Address } from '@app/core/business/address';
import { Order } from '@app/core/business/order/order';
import { ContextService } from '@app/core/service/context.service';
import { CustomerService } from '@app/core/business/customer/customer.service';
import { TranslateService } from '@ngx-translate/core';
import { NgForm } from '@angular/forms';
import { OrderType } from '@app/core/business/order/orderType';
import { DeliveryDate } from '@app/core/business/order/delivery-date';
import { interval } from 'rxjs';

@Component({
  selector: 'app-validate-order',
  templateUrl: './validate-order.component.html',
  styleUrls: ['./validate-order.component.scss'],
})
export class ValidateOrderComponent implements OnInit {
  public datas: { order: Order; addresses: Address[]; };
  public dates: DeliveryDate[]; // CLA le 10/10/2019 - A/B - passage des dates de livraisons en objet
  public loadingDates = false;
  public disableDateSelection = false;

  constructor(
    private injector: Injector,
    private modalService: ModalService,
    public contextService: ContextService,
    private customerService: CustomerService,
    public translateService: TranslateService
  ) {
    this.datas = this.injector.get('datas');
  }

  ngOnInit() {
    if (Order.hasDateCourte(this.datas.order)) {
      this.disableDateSelection = true;
    }
    if (
      !this.contextService.fullContext.company.settings
        .orderDeliveryDateRequired &&
      this.datas.order.deliveryAddress &&
      this.datas.order.deliveryAddress.code
    ) {
      this.fetchDates();
    }
  }

  public close(): void {
    this.modalService.destroy();
  }

  public validate(): void {
    this.modalService.validate(this.datas.order);
  }

  public setAddress(event: any): void {
    this.datas.order.deliveryAddress = this.datas.addresses.find(
      a => a.code === event.target.value
    );

    this.fetchDates();
  }

  /**
   * Permet de formater une date au meme format qu'elle soit UTC ou locale
   * @param dateString 
   * @returns 
   */
  public normalize(dateString: string): string {
    if (!dateString) return '';

    return dateString.substring(0, 10);
  }


  public fetchDates(): void {
    this.customerService
      .getDeliveryDates(
        this.contextService.context.companyCode,
        this.contextService.context.customerCode,
        this.datas.order.deliveryAddress.code,
        this.datas.order.orderType
      )
      .subscribe(
        dates => {
          this.dates = dates;
          // Si une date de livraison est déjà sélectionnée, on la remet à jour avec la version "exacte" de la liste.
          const current = this.datas.order.deliveryDate;
          if (!current) {
            return;
          }
          const currentDay = this.normalize(this.datas.order.deliveryDate);

          const found = this.dates.find(d => {
            return this.normalize(d.deliveryDate) === currentDay
          });
          if (found) {
            // Là tu remplaces par la version EXACTE venant de la liste (avec Z)
            this.datas.order.deliveryDate = found.deliveryDate;
          }
        },
        () => {
          this.loadingDates = false;
        },
        () => {
          this.loadingDates = false;
        }
      );
  }

  /**
   * Permet de définir la valeur de la date de livraison au changement dans la liste.
   * CLA le 09/10/2019 : la liste des dates de livraison est désormais une liste d'objet "core.business.order.DeliveryDate"
   * @param event
   */
  public setDeliveryDate(event: any): void {
    this.datas.order.deliveryDate = this.dates.find(
      a => a.deliveryDate === event.target.value
    ).deliveryDate;
  }

  /**
   * Permet de bloquer la validation
   * Si une adresse est requise
   */
  public disableValidation(): boolean {
    let validationDisabled: boolean;

    // Autorisation par défaut, si une des conditions n'est pas respecté, on interdit la validation
    validationDisabled = false;

    // Une date est requise et il n'y a pas de date de livraison
    if (this.contextService.fullContext.company.settings.orderDeliveryDateRequired && !this.datas.order.deliveryDate) {
      validationDisabled = true;
    }

    // Une adresse de livraison est requise et il n'y a pas d'adresse de livraison
    if (this.contextService.fullContext.company.settings.orderAddressRequired && (!this.datas.order.deliveryAddress || !this.datas.order.deliveryAddress.code)) {
      validationDisabled = true;
    }

    return validationDisabled;
  }
}
